<template>
	<div>
		<span v-if="displayedValues.length === 0">N/A</span>
		<span v-for="value in displayedValues" :key="`field-${ field.id }-${ value }`" class="tag brand-bg">{{ value }}</span>
		<span v-if="hasTruncated" class="tag brand-bg">+{{ (values || []).length - 2 }} More</span>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import RowTemplateBuilder from '@/utils/RowTemplateBuilder';
import StatusFields from '@/mixins/StatusFields';
import getRelationKey from '@/views/sections/app/modules/components/fields/get-relation-key';

export default {

	mixins: [ StatusFields ],

	props: [ 'row', 'field' ],

	computed: {

		...mapGetters(['modulesByTableName']),

		values() {
			return new RowTemplateBuilder(this.modulesByTableName, this.field).convert(this.row, getRelationKey(this.field, this.row));
		},
	},
};

</script>
